import * as React from 'react';
import { SEND_ICON } from 'shared/images/icons/send-icon';

function SvgComponent(props) {
  return (
    <svg
      viewBox={SEND_ICON.viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth={SEND_ICON.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}>
      {SEND_ICON.paths.map(d => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}

export default SvgComponent;
